import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const generateContentBlockWidgetInputSchema_ = z.object({});

export const generateContentBlockWidget = {
  name: "generateContentBlockWidget" as const,
  input: generateContentBlockWidgetInputSchema_,
  output: zExt.objectId(),
};
